<template>
  <div class="offerLandings">
    <div class="offerLandings__block">
      <h1 class="offerLandings__title">
        <span class="offerLandings__br">{{$t('promo_title.item_1')}} <span class="offerLandings__title-span trigger-form">{{months}} <i><img src="./assets/img/lines-minutes.svg"></i></span></span>
        <span>{{$t('promo_title.item_2')}}</span>
        <span>{{$t('promo_title.item_3')}}</span>
      </h1>
      <SpecialPromo :descFirst="descFirst" :descSecond="descSecond" />
    </div>
    <div class="offerLandings__image" :class="styles"></div>
    </div>
</template>

<script>
import SpecialPromo from './SpecialPromo.vue'
export default {
  name: 'LandingOfferPromo',
  props: ['styles', 'months', 'descFirst', 'descSecond'],
  components: {
    SpecialPromo
  }
}
</script>
